export default __webpack_public_path__ + "static/media/illustration-study-1-n-w@3x.31ed7043.webp";